import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-intl-redux'
import store from './store/index'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'antd/dist/antd.css'
import './index.css'

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'))
serviceWorker.register()